import { render, staticRenderFns } from "./PackingTypesPage.vue?vue&type=template&id=e19f890a&"
import script from "./PackingTypesPage.vue?vue&type=script&lang=js&"
export * from "./PackingTypesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports